import { Box, Button, Center, Image, Space, Stack, Text } from "@mantine/core";
import { DefaultLayout } from "../../components/DefaultLayout/DefaultLayout";
import { useNavigate } from "react-router-dom";
import MethodMaterialsLogo_NoBackground from '../../assets/mmLogo_NoBackgroundFinal.png'

export const ForbiddenPage = () : JSX.Element => {
    /* Local State */
    const navigate = useNavigate();

    return(
        <DefaultLayout showNavBar={false} showSearchBar={false} showFooter={false}>
            <Box>
                <Space h={'8em'} />
                <Stack pl={'5%'} pr={'5%'}>
                    <Center>
                        <Image src={MethodMaterialsLogo_NoBackground} w={'8em'} h={'8em'}/>
                    </Center>
                    <Center>
                        <Text c={'#121212'} fz={30} fw={'bold'}>403 Forbidden</Text>
                    </Center>
                    <Center>
                        <Text c={'#121212'} ta={'center'}>We're sorry! This page is currently unavailable</Text>
                    </Center>
                    <Space h={'1em'} />
                    <Center>
                        <Button variant="outline" radius={'5em'} color={'#003262'} pl={'5%'} pr={'5%'} onClick={() => {
                            navigate('/');
                        }}>Go to home</Button>
                    </Center>
                    <Space h={'40em'} />
                </Stack>
            </Box>
        </DefaultLayout>
    );
}